import type { ReactElement } from "react";

import { ChargeTenant } from "./charge-rows.js";
import type { CenterPausedSubscription } from "./charge-types.js";

/**
 * 停止中の定期課金。<b>止まっている間は課金されない</b>——支払いの失敗で止まった可能性が高く、サポートから契約者へ連絡する。
 * 期間・結果・語に依らず、契約 ID で絞っていればその契約だけ（サーバが決める）。<b>無ければ 1 行だけ</b>小さく出す。
 * 出すのはサーバが返した分まで（多くても 50 件）。数がそれを超えたらその旨を出す。
 */
export function PausedSubscriptions({ rows, count }: {
    readonly rows: readonly CenterPausedSubscription[];
    readonly count: number;
}): ReactElement {
    if (count === 0) {
        return <p className="mb-4 text-xs text-slate-500" data-charge-paused="">停止中の定期課金はありません。</p>;
    }
    return (
        <section className="card mb-4 p-6" data-charge-paused="">
            <h2 className="section-title">{`停止中の定期課金（${String(count)} 件）`}</h2>
            <div className="alert-warning mb-3">
                停止中の定期課金は課金されません。支払いの失敗で止まった可能性が高いので、サポートから契約者へ連絡してください。
            </div>
            {count > rows.length
                ? (
                    <p className="mb-3 text-xs text-slate-500" data-charge-paused-more="">
                        {`停止中は ${String(count)} 件あります。ここには ${String(rows.length)} 件までを出します。契約 ID で絞ると、その契約の分を出せます。`}
                    </p>
                )
                : null}
            <div className="table-scroll">
                <table className="data-table">
                    <thead>
                        <tr>
                            <th scope="col">止まった日時</th>
                            <th scope="col">契約</th>
                            <th scope="col">金額</th>
                            <th scope="col">定期課金の ID</th>
                        </tr>
                    </thead>
                    <tbody>
                        {rows.map((row) => (
                            <tr key={row.subscriptionId}>
                                <td className="whitespace-nowrap text-slate-500">{row.pausedLabel}</td>
                                <td><ChargeTenant row={row} /></td>
                                <td className="whitespace-nowrap">{row.amountLabel}</td>
                                <td className="text-xs text-slate-500">{row.subscriptionId}</td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </section>
    );
}
